import { ReactNode } from 'react';
import styles from './style.module.scss';

type Props = {
  children: ReactNode
}

const Notice = ({ children }: Props) => {
  return (
    <div className={styles.notice}>
      {children}
    </div>
  )
}

export { Notice }
